import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Demo from "./pages/demo";
import BillingMachinePage from './pages/billingMachinePage';
import BillingMachinePagePdfViewT20 from './pages/pdfViews/billingMachinePdfViewT20';
import BillingMachinePagePdfViewT90 from './pages/pdfViews/billingMachinePdfViewT90';
import BillingMachinePagePdfViewZIP20 from './pages/pdfViews/billingMachinePdfViewZIP20';
import BillingMachinePagePdfViewHandy from './pages/pdfViews/billingMachinePdfViewHandy';
import BillingMachinePagePdfViewT10 from './pages/pdfViews/billingMachinePdfViewT10';
import NoteCountingMachinePage from './pages/noteCounting/noteCountingMachinePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import BillZappPage from './pages/billzapp/BillZappPage';
import ProductsPage from './pages/products/ProductsPage';
import ProductDetailPage from './pages/products/ProductDetailPage';
import AccountPage from './pages/account/AccountPage';
import { AccountProvider } from './components/accountContext.jsx';

function App() {


  
  return (
    <Router>
      <AccountProvider>
      <div className="app-container">

        <Routes>
          <Route exact path="/" element={<Demo/>} />
        </Routes>
        <Routes>
          <Route exact path="/billingMachines" element={<BillingMachinePage/>} />
        </Routes>
        <Routes>
          <Route exact path="/billingMachinesPdfT20" element={<BillingMachinePagePdfViewT20/>} />
        </Routes>
        <Routes>
          <Route exact path="/billingMachinesPdfT90" element={<BillingMachinePagePdfViewT90/>} />
        </Routes>
        <Routes>
          <Route exact path="/billingMachinesPdfZIP20" element={<BillingMachinePagePdfViewZIP20/>} />
        </Routes>
        <Routes>
          <Route exact path="/billingMachinesPdfHandy" element={<BillingMachinePagePdfViewHandy/>} />
        </Routes>
        <Routes>
          <Route exact path="/billingMachinesPdfT10" element={<BillingMachinePagePdfViewT10/>} />
        </Routes>
        <Routes>
          <Route exact path="/noteCountingMachines" element={<NoteCountingMachinePage/>} />
        </Routes>
        <Routes>
          <Route exact path="/privacy-policy" element={<PrivacyPolicy/>} />
        </Routes>
        <Routes>
          <Route exact path="/terms-and-conditions" element={<TermsAndConditions/>} />
        </Routes>
        <Routes>
          <Route exact path="/billzapp" element={<BillZappPage/>} />
        </Routes>
        <Routes>
          <Route exact path="/products" element={<ProductsPage/>} />
        </Routes>
        <Routes>
          <Route path="/products/:bundleId" element={<ProductDetailPage/>} />
        </Routes>
        <Routes>
          <Route exact path="/account" element={<AccountPage/>} />
        </Routes>

      </div>
      </AccountProvider>
    </Router>
    // <Router>
    //   <Switch>
    //     {/* <Route exact path="/">
    //       {user ? <Home /> : <Register />}
    //     </Route>
    //     <Route path="/login">{user ? <Redirect to="/" /> : <Login />}</Route>
    //     <Route path="/register">
    //       {user ? <Redirect to="/" /> : <Register />}
    //     </Route> */}
    //     <Route path="/">
    //       <demo />
    //     </Route>
    //   </Switch>
    // </Router>
  );
}

export default App;
